import { ofType } from 'redux-observable';
import { exhaustMap } from 'rxjs/operators';

import { addToastAction as addToast } from '@perpay-web/components/base/ToastProvider/useToastContext';
import { analyticsSelfServicePhoneUpdateSuccess } from '@perpay-web/fintech/actions/analytics/userInfo';
import {
    updatePhoneNumber as updatePhoneNumberAction,
    updatePhoneNumberError as updatePhoneNumberErrorAction,
    updatePhoneNumberContext,
    updatePhoneNumberSuccess,
    updatePhoneNumberContextSuccess,
    verifyNewPhoneNumber as verifyNewPhoneNumberAction,
    verifyNewPhoneNumberError as verifyNewPhoneNumberErrorAction,
    verifyNewPhoneNumberContext,
    verifyNewPhoneNumberSuccess,
    verifyNewPhoneNumberContextSuccess,
} from '@perpay-web/fintech/actions/entities/phoneNumber';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import {
    VERIFY_PHONE,
    VERIFY_MFA,
    editPhoneSetSteps,
} from '@perpay-web/fintech/components/screens/EditPhone/useEditPhoneContext';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';

export function updateUserPhone(action$, state$) {
    return action$.pipe(
        ofType(updatePhoneNumberAction().type),
        exhaustMap((action) =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: [updatePhoneNumberContext(action.payload)],
                waitFor: [updatePhoneNumberContextSuccess().type],
                waitForDispatch: (state, results) => [
                    updatePhoneNumberSuccess(results[0].payload),
                    editPhoneSetSteps(VERIFY_PHONE),
                ],
                errors: [updatePhoneNumberErrorAction().type],
            }),
        ),
    );
}

export function verifyNewPhone(action$, state$) {
    return action$.pipe(
        ofType(verifyNewPhoneNumberAction().type),
        exhaustMap((action) =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: [verifyNewPhoneNumberContext(action.payload)],
                waitFor: [verifyNewPhoneNumberContextSuccess().type],
                waitForDispatch: (state, results) => [
                    verifyNewPhoneNumberSuccess(results),
                    analyticsSelfServicePhoneUpdateSuccess(action.payload),
                    routeToLocation(paths.profile.path),
                    addToast({ message: 'Phone updated' }),
                    // reset steps
                    editPhoneSetSteps(VERIFY_MFA),
                ],
                errors: [verifyNewPhoneNumberErrorAction().type],
            }),
        ),
    );
}
